import gql from 'graphql-tag'

export const mutation = gql`
  mutation deleteFinancialAccount($id: Int!) {
    record: delete_finance_financial_account_by_pk(id: $id) {
      id
    }
  }
`

export default mutation
